import _extends from 'babel-runtime/helpers/extends';

import clip from '@/utils/clipboard'; // use clipboard directly
import useValueExchangeLabel from '@/utils/useValueExchangeLabel';
import { channelList } from '@com/utils/channel';
import { clickConfList } from '@/common/material-metadata';
import { v2Host } from '@/config/host';

export default {
  props: {
    config: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },

  methods: {
    handleCopyLink: function handleCopyLink(text, event) {
      clip(text, event);
      this.$message({
        type: 'success',
        message: '复制成功'
      });
    },
    getChannelName: function getChannelName(row) {
      var clickStr = row.click_type && Number(row.click_type) !== 0 ? ' - ' + useValueExchangeLabel(row.click_type, clickConfList) : '';
      var platFormStr = row.platform ? '-' + row.platform : '';
      var orientationStr = Number(row.orientation) !== 3 ? ' - ' + (Number(row.orientation) === 1 ? '横屏' : '竖屏') : '';
      var channel = '' + useValueExchangeLabel(row.channel_id, channelList) + platFormStr + clickStr + orientationStr;
      return Number(row.channel_id) !== 0 ? channel : '-';
    }
  },

  computed: {
    innerConfig: function innerConfig() {
      return _extends({}, this.config);
    },
    downloadUrl: function downloadUrl() {
      return v2Host + '/dmaker/custom/download';
    }
  }
};